import React from "react";
import { Modal } from "react-bootstrap";

const DeleteDialog = ({
  isDeleteDialogOpen,
  setIsDeleteDialogOpen,
  handleDeleteConfirm,
  message,
}) => {
  return (
    <Modal
      show={isDeleteDialogOpen}
      onHide={() => setIsDeleteDialogOpen(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message || "Are you sure you want to delete this item?"}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={() => setIsDeleteDialogOpen(false)}
        >
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={() => {
            handleDeleteConfirm();
            setIsDeleteDialogOpen(false);
          }}
        >
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteDialog;
